/**
 * @sync-target レクシンユーザーメッセージ一覧 > 02_確認ダイアログ一覧
 */
export const DIALOG_MESSAGES = {
  PAGE_LEAVE: {
    UNSAVED_CHANGES: "編集内容が保存されていません。ページを離れてもよろしいですか？",
  },
  DELETE: {
    KINTONE_ADMIN: "kintone管理者情報を削除しますか？",
    KNOWLEDGE: (title: string) => `「${title}」を削除してもよろしいですか？` as const,
    CHAT_HISTORY: "会話履歴がすべて削除されます。よろしいですか？",
  },
  NAVIGATION: {
    EXTERNAL_PAGE: (feedbackUrl: string) =>
      `別のページに遷移します。よろしいですか？\n${feedbackUrl}` as const,
  },
  CREDIT_CONSUME: {
    APP_GENERATION_TITLE: "クレジットを使用してアプリを生成",
    APP_GENERATION_BODY: (creditCost: number) =>
      `アプリ生成回数が残っていません。${creditCost}クレジットを消費してアプリを生成しますか？` as const,
    APP_GENERATION_REMAINING_CREDIT: (remainingCredit: number) =>
      `残りクレジット: ${remainingCredit}` as const,
  },
  LOOKUP_TYPE_BLOCK: {
    TITLE: "アプリを生成できません",
    DESCRIPTION:
      "フィールド設計書のルックアップ設定にフィールドタイプが一致しない項目があります。下記を修正してから再度生成してください。",
    HELP_LINK_TEXT:
      "設定できるフィールドの組み合わせは[kintoneヘルプ（ほかのフィールドのコピー）](https://jp.kintone.help/k/ja/app/form/lookup/otherfield_copy.html)を参照してください。",
    ERROR_LIST_LABEL: "フィールドタイプ不整合の一覧",
    CLOSE_BUTTON: "閉じる",
    NAVIGATE_TO_FIELD_DESIGN_BUTTON: "フィールド設計書を修正する",
  },
} as const;
